import { Endpoint } from '@square/ignition';
import { HttpMethodString, HttpMethods } from '@squareup/dex-ui';
import { Markdown } from '@squareup/dex-ui-markdown';
import {
  Box,
  Display10,
  Paragraph20,
  Paragraph30,
} from '@squareup/dex-ui-shared-base';
import { breakHtmlForSlashReact, humanizeName } from '@squareup/dex-utils-text';
import React, { FC, memo } from 'react';

import styles from './api-explorer-endpoint-heading.module.css';

interface Props {
  summary: string;
  endpoint?: Endpoint | undefined;
}

const ApiExplorerEndpointHeading: FC<Props> = memo(({ summary, endpoint }) => {
  if (!endpoint) {
    return null;
  }

  return (
    <Box margin={{ bottom: '3x' }}>
      <Box>
        {endpoint.isDeprecated ? (
          <>
            <HttpMethodString as="span" httpMethod="DEPRECATED" />
            <Paragraph30 as="span">
              &nbsp; - {endpoint.httpMethod.toUpperCase()}
            </Paragraph30>
            &nbsp;
          </>
        ) : (
          <HttpMethodString
            as="span"
            httpMethod={endpoint.httpMethod.toUpperCase() as HttpMethods}
          />
        )}
        <Paragraph20 as="span" className={styles['code-font']}>
          {breakHtmlForSlashReact(endpoint.path)}
        </Paragraph20>
      </Box>
      <Display10>{humanizeName(endpoint.name)}</Display10>
      <Paragraph30
        margin={{ top: '0.5x' }}
        className={styles['endpoint-desc']}
        as="span"
      >
        <Markdown markdown={summary} />
      </Paragraph30>
    </Box>
  );
});

ApiExplorerEndpointHeading.displayName = 'ApiExplorerEndpointHeading';

export { ApiExplorerEndpointHeading };
